"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_SELECTED_OBJECTS_UUIDS = void 0;
// eslint-disable-next-line import/prefer-default-export
exports.SET_SELECTED_OBJECTS_UUIDS = 'SET_SELECTED_OBJECTS_UUIDS';
